// extracted by mini-css-extract-plugin
module.exports = {"userAvatarWrapper":"user-avatar_userAvatarWrapper__4Tcm9","image":"user-avatar_image__bTo6P","loaded":"user-avatar_loaded__tgFRx"};